"use client";

import { useEffect } from "react";
import { toast } from "shared-components";
import useSWR from "swr";

import { getProductsListsForHome } from "@/api/product";
import { Header } from "@/components/Header";
import { HomeCommonThemesCarousel } from "@/components/home/CommonThemesCarousel";
import { HomeLicensedThemesCarousel } from "@/components/home/LicensedThemesCarousel";
import { Footer } from "@/components/Footer";
import { HomeCustomizeBanner } from "@/components/home/CustomizeBanner";
import { HomeMainCarousel } from "@/components/home/MainCarousel";
import { HomeMainSections } from "@/components/home/MainSections";
import { ProductGroup } from "@/components/product/ProductGroup";
import { useThemes } from "@/hooks/use-themes";
import { FirstBanner } from "@/components/home/Banners/FirstBanner";
import { ThirdBanner } from "@/components/home/Banners/ThirdBanner";
import { SecondBanner } from "@/components/home/Banners/SecondBanner";

export default function MainPage() {
  const {
    data: productsData,
    error: productsError,
    isLoading: loadingProducts,
  } = useSWR("/products/home", getProductsListsForHome);

  const { commonThemes } = useThemes();

  useEffect(() => {
    const errorMessage = productsData?.error?.message || productsError?.response?.message;

    if (errorMessage) {
      toast.error(errorMessage + "");
    }
  }, [productsData, productsError]);

  return (
    <div className="flex min-h-screen flex-col overflow-x-hidden">
      <Header />

      <div className="pb-[13.5rem] flex flex-col items-center lg:pb-13 relative w-full after:absolute after:bottom-0 after:content-[''] after:inset-x-0 after:h-[2] after:bg-gradient-to-r after:from-brand-yellow after:via-brand-accent after:to-brand-variation-2">
        <HomeMainCarousel slides={[FirstBanner, ThirdBanner, SecondBanner]} />

        {/* TEMPORARIAMENTE REMOVIDO — pode ser realocado futuramente */}
        {/*<HomeMainSections className="pb-5 pt-6" />*/}

        {/* TEMPORARIAMENTE REMOVIDO — pode ser realocado futuramente */}
        {/*<HomeCommonThemesCarousel themes={commonThemes} className="pb-6 pt-3" />*/}

        {/* TEMPORARIAMENTE REMOVIDO — pode ser realocado futuramente */}
        {/*<HomeLicensedThemesCarousel className="pb-10 pt-10 bg-brand-primary-opacity-10" />*/}

        <ProductGroup
          id="featured"
          title="Produtos em alta"
          products={productsData?.mostPopular || []}
          loading={loadingProducts}
          className="mb-10 -mt-[-.3rem]"
        />

        <ProductGroup
          id="popular"
          title="Mais vendidos"
          products={productsData?.mostSelled || []}
          loading={loadingProducts}
          className="mb-10"
        />

        <ProductGroup
          id="recent"
          title="Mais recentes"
          products={productsData?.mostRecent || []}
          loading={loadingProducts}
          className="mb-11 pt-10"
        />

        <HomeCustomizeBanner />
      </div>

      <Footer />
    </div>
  );
}
